import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import SubSection1 from "./Subsection1";
import Subsection1b from "./Subsection1b";
import SubSection2 from "./Subsection2";
import SubSection3 from "./Subsection3";
import SubSection4 from "./Subsection4";
import TextBasedResponse from "./Subsection5";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface OverallImpressionsProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const OverallImpressions:FC<OverallImpressionsProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("Overall Impressions", true);
  }, [toggleSection])

  useEffect(() => {
    if (subsection === "the-top-change-to-convince-faculty-to-stay" || subsection === "responses-to-other-prompts-top-change") {
      toggleSection("Overall Impressions/The top change to convince faculty to stay", true);
    }
  }, [toggleSection, subsection])

  return (
    <>
      <BreadcrumbNav section="overall-impressions" subsection={subsection} />

      <h1>Overall Impressions</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "the-top-change-to-convince-faculty-to-stay" && <SubSection1 />}
      {subsection === "responses-to-other-prompts-top-change" && <Subsection1b />}
      {subsection === "satisfaction-with-retention-efforts" && <SubSection2 />}
      {subsection === "recommendation-of-department" && <SubSection3 />}
      {subsection === "likelihood-to-seek-or-entertain-a-job-offer" && <SubSection4 />}
      {subsection === "additional-comments-about-decision" && <TextBasedResponse />}
      
      <BottomNavigation />
    </>
  )
}

export default OverallImpressions;